import { EntradaProduto } from "../../domain/models/entrada_produtos_lista";
import { IGetAllEstoqueUseCase } from "../useCases/read/get_all_estoque_use_case";
import { UserFriendlyError } from "../../../../common/utils/base_error";

export const loadEntradaProdutosSessao = async (
  useCase: IGetAllEstoqueUseCase,
  idSessaoMultipla: string,
): Promise<EntradaProduto[]> => {
  if (!idSessaoMultipla?.trim()) {
    throw new UserFriendlyError("A inclusão não retornou o identificador da sessão. Atualize a lista para conferir os produtos gravados.");
  }

  const items: EntradaProduto[] = [];
  let page = 1;

  // A sessão tem filtros e paginação próprios, independentes da listagem.
  do {
    await useCase.getAllListagemEstoque({ IdSessaoMultipla: idSessaoMultipla }, page, 100);
    // O servidor já filtra pela sessão. Não descartar os registros retornados
    // por diferenças na representação (ou ausência) desse campo na resposta.
    items.push(...useCase.items);
    page += 1;
  } while (page <= useCase.totalPages);

  return items;
};
